import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { ArrowCircleRightIcon } from '@10xLabs/react-web/components/Icons/ArrowCircleRight'
import { FormattedRoute } from '@10xLabs/react-web/components/FormattedRoute'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { CheckInScore } from 'features/Bookings/components/CheckInScore'
import { GTBookingV2Trip } from 'gql/types.generated'
import { ReactElement } from 'react'

const DepartureTime = styled.div`
  font-size: 13px;
  color: #9999bd;
`

interface ITripProps {
  trip: GTBookingV2Trip
}

const Trip = ({ trip }: ITripProps): TSFixMe => {
  const intl = useIntl()
  const departureTimezone = trip.segment.origin.city.timezone

  return (
    <div>
      <FormattedRoute origin={trip.segment.origin} destination={trip.segment.destination} />
      <div>
        <FormattedDate
          intl={intl}
          value={trip.segment.departureAt}
          month="2-digit"
          day="2-digit"
          year="numeric"
          timeZone={departureTimezone || undefined}
        />
      </div>
      <DepartureTime>
        <FormattedTimeByDate intl={intl} date={trip.segment.departureAt} timeZone={departureTimezone || undefined} />
      </DepartureTime>
      <CheckInScore checkInScore={trip.checkInScore} />
    </div>
  )
}

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`

export const Label = styled.div<TSFixMe>`
  font-weight: 500;
  white-space: nowrap;
`

interface IDepartureTripsProps {
  departureTrips: GTBookingV2Trip[]
  showReturnTrips?: boolean
}

const DepartureTrips = ({ departureTrips, showReturnTrips }: IDepartureTripsProps): ReactElement | null => {
  if (departureTrips.length === 0) return null

  const trip = departureTrips[0]

  return (
    <div>
      {showReturnTrips && (
        <LabelWrapper>
          <ArrowCircleRightIcon />
          <Label>
            <FormattedMessage id="dictionary.departure" defaultMessage="Departure" />
          </Label>
        </LabelWrapper>
      )}
      <Trip trip={trip} />
    </div>
  )
}

export const ReturnTripsWrapper = styled.div<{ showDepartureTrips?: boolean }>`
  margin-top: ${({ showDepartureTrips }): string => (showDepartureTrips ? '20px' : '0')};
`

export const ReturnIcon = styled(ArrowCircleRightIcon)`
  transform: rotate(180deg);
`

interface IReturnTripsProps {
  returnTrips: GTBookingV2Trip[]
  showDepartureTrips?: boolean
}

const ReturnTrips = ({ returnTrips, showDepartureTrips }: IReturnTripsProps): ReactElement | null => {
  if (returnTrips.length === 0) return null

  const trip = returnTrips[0]

  return (
    <ReturnTripsWrapper showDepartureTrips={showDepartureTrips}>
      {showDepartureTrips && (
        <LabelWrapper>
          <ReturnIcon />
          <Label>
            <FormattedMessage id="dictionary.return" defaultMessage="Return" />
          </Label>
        </LabelWrapper>
      )}
      <Trip trip={trip} />
    </ReturnTripsWrapper>
  )
}

interface IBookingServiceProps {
  departureTrips: GTBookingV2Trip[]
  returnTrips?: GTBookingV2Trip[]
  showReturnTrips?: boolean
  showDepartureTrips?: boolean
}

export const BookingService = ({
  departureTrips,
  returnTrips,
  showReturnTrips,
  showDepartureTrips
}: IBookingServiceProps): ReactElement => {
  return (
    <div>
      {showDepartureTrips && <DepartureTrips departureTrips={departureTrips} showReturnTrips={showReturnTrips} />}
      {showReturnTrips && <ReturnTrips returnTrips={returnTrips || []} showDepartureTrips={showDepartureTrips} />}
    </div>
  )
}
